import { createFileRoute } from '@tanstack/react-router';
import { CdpRouteView } from '@/pages/workspaces/integrations/cdp/cdp-route-view';
import { LastWorkspaceResolver } from './-components';

/**
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware branch of the resolver
 * rebuilds the target from the bundle prefix — which would find no `/journeys/` here, drop the
 * sub-path, and land on the Journeys home instead of this redirect.
 */
function CdpOutRoute() {
  return (
    <LastWorkspaceResolver>
      <CdpRouteView connector="cdp_out" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/cdp_out')({
  component: CdpOutRoute,
});
